<template>
  <div class="row">
    <div class="col-xs-12">
      <button type="button" class="btn btn-primary btn-voltar" @click="$router.back()">
        <font-awesome-icon :icon="'arrow-left'"/>
        Voltar
      </button>
      <h1 class="page-header">Adicionar Eixos</h1>
      <div class="row">
        <div class="col-xs-12">
          <form role="form" @submit.prevent="save()" id="tag_form">
            <fieldset>
              <!-- Text input-->
              <div :class="['form-group', { 'has-error': errors.has('eixo') }]">
                <label
                  :class="[
                    'col-xs-12',
                    'control-label',
                    'custom-font',
                    { 'is-danger': errors.has('eixo') }
                  ]"
                  >Nome do eixo</label
                >
                <div class="col-xs-12 col-sm-8 inputGroupContainer">
                  <div class="input-group">
                    <span class="input-group-addon"
                      ><font-awesome-icon
                        :icon="'id-card'"
                        :class="[{ 'is-danger': errors.has('eixo') }]"
                      ></font-awesome-icon
                    ></span>
                    <input
                      ref="eixo"
                      v-model="model.EIX_DCEIXO"
                      name="eixo"
                      v-validate="'required'"
                      maxlength="250"
                      :class="[
                        'form-control',
                        { 'is-danger': errors.has('eixo') }
                      ]"
                      placeholder="Eixo"
                      type="text"
                    />
                    <div
                      :class="[
                        'input-group-addon custom-input-group-addon-count',
                        { 'is-danger': errors.has('eixo') }
                      ]"
                      v-text="250 - model.EIX_DCEIXO.length"
                    ></div>
                  </div>
                  <small
                    v-if="errors.has('eixo')"
                    data-bv-validator="notEmpty"
                    data-bv-validator-for="eixo"
                    class="help-block"
                    style=""
                  >
                    <font-awesome-icon
                      :icon="'exclamation-triangle'"
                      :class="[{ 'is-danger': errors.has('eixo') }]"
                    ></font-awesome-icon>
                    {{ errors.first('eixo') }}
                  </small>
                </div>
              </div>

              <!-- Button -->
              <div class="form-group">
                <div class="">
                  <button
                    @click.prevent="save()"
                    class="btn btn-default"
                    :disabled="carregando"
                  >
                    <font-awesome-icon
                      v-if="carregando"
                      :icon="'spinner'"
                      spin
                    />
                    <font-awesome-icon v-else :icon="'save'" />
                    Salvar
                  </button>
                </div>
              </div>
            </fieldset>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.custom-font {
  font-size: 16px;
  color: #00615c;
}

.custom-input-group-addon-count {
  color: #00615c;
}

.fa-id-card {
  color: #00615c;
}

.custom-font.is-danger {
  color: #990000;
}

.custom-input-group-addon-count.is-danger {
  color: #990000;
}

.fa-id-card.is-danger {
  color: #990000;
}

.btn-voltar {
  margin-top: 20px;
}
</style>

<script>
import { request } from '@/request'

export default {
  name: 'eixo-save',
  data() {
    return {
      model: {
        EIX_DCEIXO: ''
      }
    }
  },
  beforeCreate() {
    if (!this.$store.state.isLogged) {
      this.$router.push('/login')
    }
  },
  mounted() {
    var params = this.$router.history.current.params
    if (params.hasOwnProperty('id')) {
      this.model.EIX_IDEIXO = params.id
      this.model.EIX_DCEIXO = params.name
    }
    this.$refs.eixo.focus()
  },
  methods: {
    saveSuccess(result) {
      this.$toastr.s('Este item foi salvo com sucesso.')
      this.$router.push('list')
    },
    saveFail(result) {
      this.$toastr.e('Houve uma falha ao tentar salvar este item.')
    },
    save() {
      this.$validator.validateAll().then(result => {
        if (!result) {
          this.$refs[this.$validator.errors.items[0].field].focus()
          this.$toastr.e(this.$validator.errors.items[0].msg)
          return
        }

        request
          .post(`eixos/save`, this.model)
          .then(this.saveSuccess)
          .catch(this.saveFail)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/admin/eixos/Save.vue